import { getModuleFederatedName, setupServiceInfo } from '@estee/elc-universal-utils';
import { ServiceManager } from '@estee/elc-service';
import serviceNames, { StoresService } from '~setup/StoresService';
import {
    STORES_DIRECTORY,
    STORES,
    STORE_DETAILS,
    PICK_UP_IN_STORE,
    FIND_IN_STORE_MODAL,
    FIND_IN_STORE_BUTTON,
    BUY_ONLINE_PICKUP_IN_STORE_MODAL,
    STORE_NOTIFICATION
} from '@estee/elc-service-view-names';
import { serviceBusBaseClass } from './service-setup/ServiceBus';

import './exported/buy-online-pickup-in-store-modal/index';
import './exported/find-in-store-button/index';
import './exported/find-in-store-modal/index';
import './exported/pickup-in-store/index';
import './exported/store-details/index';
import './exported/store-notification/index';
import './exported/stores/index';
import './exported/stores-directory/index';

setupServiceInfo(__serviceInfo__);

const { name, version } = __serviceInfo__;

StoresService.setViews(name, getModuleFederatedName(name), version, [
    STORES_DIRECTORY,
    STORES,
    STORE_DETAILS,
    PICK_UP_IN_STORE,
    FIND_IN_STORE_MODAL,
    FIND_IN_STORE_BUTTON,
    BUY_ONLINE_PICKUP_IN_STORE_MODAL,
    STORE_NOTIFICATION
]);

ServiceManager.setServiceStartParams({
    serviceName: name,
    diContainerImport: () => import('~setup/diContainer'),
    serviceKey: serviceNames.storesService,
    serviceBusControllerKey: serviceNames.serviceBusController,
    serviceBus: {
        serviceBusBaseClass
    }
});
